import React from "react";
import { mapQueryTypeToDataTable as mapData } from "./Helper";
import GetQueryTypeColumns from "./ColumnDefinition/QueryTypeColumn/GetQueryTypeColumns";
import ReusableDataTable from "src/components/table/ReusableDataTable";

const QueryTypeTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetQueryTypeColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default QueryTypeTable;
